import { Modal } from 'antd';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/CompanyGroup/CompanyGroupModel';
import { RootState } from '../../../store';
import CompanyGroupForm from '../CompanyGroupForm/CompanyGroupForm';

const CompanyGroupModal: FC<any> = () => {
  const dispatch = useDispatch();
  const reduxCompanyGroup = useSelector((state: RootState) => state.models.companyGroup);

  return (
    <Modal
      title={!!reduxCompanyGroup.id ? 'Modifica' : 'Adauga'}
      open={reduxCompanyGroup.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <CompanyGroupForm />
    </Modal>
  );
};

export default CompanyGroupModal;
